

import { Vue } from 'vue-class-component';

export default class CustomerNavDrawer extends Vue {

}
